import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20warm%20abstract%20background%20with%20traditional%20Chinese%20patterns%2C%20soft%20golden%20and%20crimson%20tones%2C%20minimalist%20aesthetic%2C%20subtle%20mahjong%20tile%20textures%20in%20the%20background%2C%20luxurious%20silk%20fabric%20folds%2C%20artistic%20composition%2C%20warm%20atmosphere%2C%20high%20quality%20render%2C%20elegant%20Chinese%20new%20year%20inspired%20color%20palette%2C%20golden%20accents%20on%20deep%20burgundy%20background&width=1800&height=900&seq=hero-bg-majiang&orientation=landscape"
          alt="麻将在线玩背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16 md:py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/15 backdrop-blur-md rounded-full border border-background-50/20 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
          <span className="text-xs md:text-sm text-background-50/90 font-medium">超过 500 万麻友的选择</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
          麻将在线玩免费网页版
        </h1>
        <p className="text-lg md:text-xl text-background-50/80 mb-2">
          无需下载即玩，随时随地免费开局
        </p>
        <p className="text-sm md:text-base text-background-50/60 max-w-2xl mx-auto mb-8">
          支持国标麻将、四川麻将、广东麻将、血流成河等多种玩法。单机练习或多人联机，打开浏览器就能和好友一起搓麻将！
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#play"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
          >
            立即免费开玩
          </a>
          <Link
            to="/category/guobiao-majiang"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/10 backdrop-blur-md text-background-50 rounded-full text-base font-medium border border-background-50/25 hover:bg-background-50/20 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            探索玩法
            <i className="ri-arrow-right-line ml-1.5"></i>
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-3 gap-4 md:gap-8 max-w-lg mx-auto">
          {[
            { icon: 'ri-download-cloud-2-line', text: '无需下载' },
            { icon: 'ri-global-line', text: '打开即玩' },
            { icon: 'ri-vip-crown-2-line', text: '完全免费' },
          ].map((item) => (
            <div key={item.text} className="flex flex-col items-center gap-2">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/20">
                <i className={`${item.icon} text-background-50 text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs md:text-sm text-background-50/70 font-medium">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}